import React, { useEffect, useId, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Multi-select dropdown with checkboxes (status, carrier filters). options: [{ value, label }], value: string[].
// onChange receives an updater (current array) => next array, so quick consecutive clicks never lose a choice.
// The button announces the count; Escape and a click outside close the panel.
const MultiSelect = ({ label, options, value, onChange, allText = 'Vše' }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const btnRef = useRef(null);
  const panelId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (!wrapRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  const toggle = (v) => onChange((cur) => (cur.includes(v) ? cur.filter((x) => x !== v) : [...cur, v]));
  const names = options.filter((o) => value.includes(o.value)).map((o) => o.label);
  const summary = names.length === 0 ? allText : names.length <= 2 ? names.join(', ') : `${names.length} vybráno`;

  const onKeyDown = (e) => {
    if (e.key === 'Escape' && open) { e.stopPropagation(); setOpen(false); btnRef.current?.focus(); }
  };
  const onBlur = (e) => {
    if (!wrapRef.current?.contains(e.relatedTarget)) setOpen(false);
  };

  return (
    <div className="shp-field">
      <span className="shp-label" id={`${panelId}-l`}>{label}</span>
      <div ref={wrapRef} className="shp-pop-wrap" onKeyDown={onKeyDown} onBlur={onBlur}>
        <button
          ref={btnRef} type="button" className="shp-select-btn" aria-haspopup="true" aria-expanded={open} aria-controls={open ? panelId : undefined}
          aria-labelledby={`${panelId}-l ${panelId}-v`} onClick={() => setOpen((o) => !o)}
        >
          <span id={`${panelId}-v`} className="shp-select-btn__text">{summary}</span>
          <ChevronDown size={18} color="#999" aria-hidden="true" />
        </button>
        {open && (
          <div id={panelId} role="group" aria-labelledby={`${panelId}-l`} className="shp-pop">
            {options.map((o) => (
              <label key={o.value} className="shp-opt">
                <input type="checkbox" checked={value.includes(o.value)} onChange={() => toggle(o.value)} />
                <span className="shp-wrap">{o.label}</span>
              </label>
            ))}
            {value.length > 0 && (
              <button type="button" className="shp-link" style={{ margin: '6px 10px 4px', minHeight: 32 }} onClick={() => onChange(() => [])}>Zrušit výběr</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelect;
